import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f69234f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-animation-panel" }
const _hoisted_2 = {
  key: 0,
  class: "element-animation"
}
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "type-title" }
const _hoisted_6 = { class: "pool-item-wrapper" }
const _hoisted_7 = ["onMouseenter", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "mask"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 添加动画 ")
const _hoisted_10 = {
  key: 1,
  class: "tip"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 选中画布中的元素添加动画")
const _hoisted_12 = { class: "sequence-content" }
const _hoisted_13 = { class: "index" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "handler" }
const _hoisted_16 = {
  key: 0,
  class: "configs"
}
const _hoisted_17 = { class: "config-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"3"} }, "持续时长：", -1))
const _hoisted_19 = { class: "config-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"3"} }, "触发方式：", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("主动触发")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("与上一动画同时")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("上一动画之后")
const _hoisted_24 = { class: "config-item" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("更换动画")

import { computed, ref, watch } from 'vue'
import { nanoid } from 'nanoid'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTAnimation } from '@/types/slides'
import { 
  ENTER_ANIMATIONS,
  EXIT_ANIMATIONS,
  ATTENTION_ANIMATIONS,
  ANIMATION_DEFAULT_DURATION,
  ANIMATION_DEFAULT_TRIGGER,
  ANIMATION_CLASS_PREFIX,
} from '@/configs/animation'
import { ELEMENT_TYPE_ZH } from '@/configs/element'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import Draggable from 'vuedraggable'

type AnimationType = 'in' | 'out' | 'attention'
interface TabItem {
  key: AnimationType
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementAnimationPanel',
  setup(__props) {

const animationEffects: { [key: string]: string } = {}
for (const effect of ENTER_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}
for (const effect of EXIT_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}
for (const effect of ATTENTION_ANIMATIONS) {
  for (const animation of effect.children) {
    animationEffects[animation.value] = animation.name
  }
}

const animationTypes: AnimationType[] = ['in', 'out', 'attention']

const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(useMainStore())
const { currentSlide, formatedAnimations, currentSlideAnimations } = storeToRefs(slidesStore)

const tabs: TabItem[] = [
  { key: 'in', label: '入场' },
  { key: 'out', label: '退场' },
  { key: 'attention', label: '强调' },
]
const activeTab = ref('in')

watch(() => handleElementId.value, () => {
  animationPoolVisible.value = false
})

const hoverPreviewAnimation = ref('')
const animationPoolVisible = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

// 当前页面的动画列表
const animationSequence = computed(() => {
  const animationSequence = []
  for (let i = 0; i < formatedAnimations.value.length; i++) {
    const item = formatedAnimations.value[i]
    for (let j = 0; j < item.animations.length; j++) {
      const animation = item.animations[j]
      const el = currentSlide.value.elements.find(el => el.id === animation.elId)
      if (!el) continue

      const elType = ELEMENT_TYPE_ZH[el.type]
      const animationEffect = animationEffects[animation.effect]
      animationSequence.push({
        ...animation,
        index: j === 0 ? i + 1 : '',
        elType,
        animationEffect,
      })
    }
  }
  return animationSequence
})

// 当前选中元素的入场动画信息
const handleElementAnimation = computed(() => {
  const animations = currentSlideAnimations.value
  const animation = animations.filter(item => item.elId === handleElementId.value)
  return animation || []
})

// 删除元素动画
const deleteAnimation = (id: string) => {
  const animations = currentSlideAnimations.value.filter(item => item.id !== id)
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 拖拽修改动画顺序后同步数据
const handleDragEnd = (eventData: { newIndex: number; oldIndex: number }) => {
  const { newIndex, oldIndex } = eventData
  if (oldIndex === newIndex) return

  const animations: PPTAnimation[] = JSON.parse(JSON.stringify(currentSlideAnimations.value))
  const animation = animations[oldIndex]
  animations.splice(oldIndex, 1)
  animations.splice(newIndex, 0, animation)
  
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 执行动画预览
const runAnimation = (elId: string, effect: string, duration: number) => {
  const elRef = document.querySelector(`#editable-element-${elId} [class^=editable-element-]`)
  if (elRef) {
    const animationName = `${ANIMATION_CLASS_PREFIX}${effect}`
    document.documentElement.style.setProperty('--animate-duration', `${duration}ms`)
    elRef.classList.add(`${ANIMATION_CLASS_PREFIX}animated`, animationName)

    const handleAnimationEnd = () => {
      document.documentElement.style.removeProperty('--animate-duration')
      elRef.classList.remove(`${ANIMATION_CLASS_PREFIX}animated`, animationName)
    }
    elRef.addEventListener('animationend', handleAnimationEnd, { once: true })
  }
}

// 修改元素动画持续时间
const updateElementAnimationDuration = (id: string, duration: number) => {
  if (duration < 100 || duration > 5000) return

  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === id) return { ...item, duration }
    return item
  })
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 修改触发方式
const updateElementAnimationTrigger = (id: string, trigger: 'click' | 'meantime' | 'auto') => {
  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === id) return { ...item, trigger }
    return item
  })
  slidesStore.updateSlide({ animations })
  addHistorySnapshot()
}

// 修改元素动画，并执行一次预览
const updateElementAnimation = (type: AnimationType, effect: string) => {
  const animations = currentSlideAnimations.value.map(item => {
    if (item.id === handleAnimationId.value) return { ...item, type, effect }
    return item
  })
  slidesStore.updateSlide({ animations })
  animationPoolVisible.value = false
  addHistorySnapshot()

  const animationItem = currentSlideAnimations.value.find(item => item.elId === handleElementId.value)
  const duration = animationItem?.duration || ANIMATION_DEFAULT_DURATION

  runAnimation(handleElementId.value, effect, duration)
}

const handleAnimationId = ref('')
// 添加元素动画，并执行一次预览
const addAnimation = (type: AnimationType, effect: string) => {
  if (handleAnimationId.value) {
    updateElementAnimation(type, effect)
    return
  }

  const animations: PPTAnimation[] = JSON.parse(JSON.stringify(currentSlideAnimations.value))
  animations.push({
    id: nanoid(10),
    elId: handleElementId.value,
    type,
    effect,
    duration: ANIMATION_DEFAULT_DURATION,
    trigger: ANIMATION_DEFAULT_TRIGGER,
  })
  slidesStore.updateSlide({ animations })
  animationPoolVisible.value = false
  addHistorySnapshot()

  runAnimation(handleElementId.value, effect, ANIMATION_DEFAULT_DURATION)
}

// 动画选择面板打开600ms后再移除遮罩层，否则打开面板后迅速滑入鼠标预览会导致抖动
const popoverMaskHide = ref(false)
const handlePopoverVisibleChange = (visible: boolean) => {
  if (visible) {
    setTimeout(() => popoverMaskHide.value = true, 600)
  }
  else popoverMaskHide.value = false
}

const openAnimationPool = (elementId: string) => {
  animationPoolVisible.value = true
  handleAnimationId.value = elementId
  handlePopoverVisibleChange(true)
}

const animations = {
  in: ENTER_ANIMATIONS,
  out: EXIT_ANIMATIONS,
  attention: ATTENTION_ANIMATIONS,
}

return (_ctx: any,_cache: any) => {
  const _component_IconEffects = _resolveComponent("IconEffects")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_IconClick = _resolveComponent("IconClick")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconCloseSmall = _resolveComponent("IconCloseSmall")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(handleElement))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Popover, {
            trigger: "click",
            visible: animationPoolVisible.value,
            "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((animationPoolVisible).value = $event)),
            onVisibleChange: _cache[3] || (_cache[3] = visible => handlePopoverVisibleChange(visible))
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                  return _createElementVNode("div", {
                    class: _normalizeClass(['tab', tab.key, { 'active': activeTab.value === tab.key }]),
                    key: tab.key,
                    onClick: ($event: any) => (activeTab.value = tab.key)
                  }, _toDisplayString(tab.label), 11, _hoisted_4)
                }), 64))
              ]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(animationTypes, (key) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (activeTab.value === key)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['animation-pool', key]),
                        key: key
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(animations[key], (effect) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "pool-type",
                            key: effect.name
                          }, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(effect.name) + "：", 1),
                            _createElementVNode("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effect.children, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "pool-item",
                                  key: item.name,
                                  onMouseenter: ($event: any) => (hoverPreviewAnimation.value = item.value),
                                  onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverPreviewAnimation.value = '')),
                                  onClick: ($event: any) => (addAnimation(key, item.value))
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["animation-box", [
                        `${_unref(ANIMATION_CLASS_PREFIX)}animated`,
                        `${_unref(ANIMATION_CLASS_PREFIX)}fast`,
                        hoverPreviewAnimation.value === item.value && `${_unref(ANIMATION_CLASS_PREFIX)}${item.value}`,
                      ]])
                                  }, _toDisplayString(item.name), 3)
                                ], 40, _hoisted_7))
                              }), 128))
                            ])
                          ]))
                        }), 128)),
                        (!popoverMaskHide.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 64))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                class: "element-animation-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAnimationId.value = ''))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconEffects, { style: {"margin-right":"5px"} }),
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_IconClick, { style: {"margin-right":"5px"} }),
          _hoisted_11
        ])),
    _createVNode(_component_Divider),
    _createVNode(_unref(Draggable), {
      class: "animation-sequence",
      modelValue: _unref(animationSequence),
      animation: 300,
      scroll: true,
      scrollSensitivity: 50,
      handle: ".sequence-content",
      onEnd: handleDragEnd,
      itemKey: "id"
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["sequence-item", [element.type, { 'active': _unref(handleElement)?.id === element.elId }]])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(element.index), 1),
            _createElementVNode("div", _hoisted_14, "【" + _toDisplayString(element.elType) + "】" + _toDisplayString(element.animationEffect), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "预览"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconPlayOne, {
                    class: "handler-btn",
                    onClick: ($event: any) => (runAnimation(element.elId, element.effect, element.duration))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["mouseEnterDelay"]),
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "删除"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconCloseSmall, {
                    class: "handler-btn",
                    onClick: ($event: any) => (deleteAnimation(element.id))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["mouseEnterDelay"])
            ])
          ]),
          (_unref(handleElementAnimation)[0]?.elId === element.elId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_Divider, { style: {"margin":"16px 0"} }),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputNumber, {
                    min: 500,
                    max: 3000,
                    step: 500,
                    value: element.duration,
                    onChange: value => updateElementAnimationDuration(element.id, value as number),
                    style: {"flex":"5"}
                  }, null, 8, ["value", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_Select, {
                    value: element.trigger,
                    onChange: value => updateElementAnimationTrigger(element.id, value as 'click' | 'meantime' | 'auto'),
                    style: {"flex":"5"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectOption, { value: "click" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SelectOption, { value: "meantime" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SelectOption, { value: "auto" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["value", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Button, {
                    style: {"flex":"1"},
                    onClick: ($event: any) => (openAnimationPool(element.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})